import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { DocumentCategoryService as ComponentService } from '../document-category.service';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import {
  DocumentCategory as objectPayload,
  DocumentCategoryAddPayload as objectAddPayload,
  DocumentCategoryEditPayload as objectEditPayload,
  DocumentCategoryForm as objectForm,
} from '../document-category.interface';

@Component({
  selector: 'app-add-document-category',
  templateUrl: './add-document-category.component.html',
  styleUrls: ['./add-document-category.component.scss'],
})
export class AddDocumentCategoryComponent {
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;
  helper = helper;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    slug: new FormControl('', [Validators.required]),
  });

  constructor(
    private dialogRef: MatDialogRef<AddDocumentCategoryComponent>,
    private componentService: ComponentService,
    private notificationService: NotificationService,

    private authService: AuthService
  ) {
    this.processToken();
  }
  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.componentService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, slug } = this.form.value as objectAddPayload;
    const newObject: objectAddPayload = {
      name,
      slug,
    };

    this.componentService
      .store(newObject)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            this.errorTitle,
            msg,
            this.errorIcon
          );
        },
      });
  }
}
